import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
} from 'vuex'

import _ from 'lodash'
import $ from 'jquery'
import {
  isMobile,
  isTablet
} from 'mobile-device-detect'
import platform from 'platform'
import { resolve } from 'promise-polyfill'

// const FetchSerieses = require('./../vuex/actions/getSerieses').default

// console.log(_config)
let _config = (function () {
  const env =
    process.env.NODE_ENV == 'development' ? 'dev' : 'prod'

  // console.log('_Mixins.js',
  //   ' look $env : ',
  //   env)

  return require(`@/config/${env}.json`)
})()

const utils = require('../utils')

const scrollTopBoundary = 500
const initScrollTop = function () {
  let _toggleScrollToTop = function (target) {
    // console.log('_Mixins.js',
    //   '_toggleScrollToTop',
    //   'target.scrollTop() :',
    //   target.scrollTop())

    if (target.scrollTop() > scrollTopBoundary) {
      //$('.scroll-top:hidden').stop(true, true).fadeIn();
      $('.scroll-top').fadeIn(200)
    } else {
      //$('.scroll-top').stop(true, true).fadeOut();
      $('.scroll-top').fadeOut(200)
    }
  }

  $(window).scroll(() => {
    _toggleScrollToTop($(window))
  })
  _toggleScrollToTop($(window))

  $('.scroll-top').click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
  })
}

// console.log(CONFIG)
// console.log('_Mixins.js', ' look $env : ', env)
// let _config = require('@/config/config.json')
// console.log(_config)

// const delayToTimeoutAgain = 100 // ms
const initPlatformAndMobileDetect = function (times = 5) {
  let runLoopCheck = function (times) {
    times -= 1

    // console.log('_Mixins.js',
    //   'initPlatformAndMobileDetect',
    //   'runLoopCheck',
    //   'times',
    //   times)
    if (times > 0) {
      setTimeout(function () {
        initPlatformAndMobileDetect(times)
      }, 200)
    }
  }

  let _addClsssToBody = (className, delay = 100) => {
    let _body = document.querySelector("body")

    // console.log('App.vue', body)
    if (!_body) {
      setTimeout(() => {
        _addClassToBody(className)
        runLoopCheck(times)
      }, delay)
      return
    }

    // console.log('_Mixins.js',
    //   '_addClsssToBody :',
    //   ' [before] ',
    //   ' @watch [className] : ',
    //   className,
    //   ' @watch [body] : ',
    //   _body)

    // let $body = $(_body)
    // $body.addClass(className)
    let classNameList = className.split(' ')
    classNameList.forEach(function (_className) {
      _body.classList.add(_className)
    })

    // console.log('_Mixins.js',
    //   '_addClsssToBody :',
    //   ' [after] ',
    //   ' @watch [className] : ',
    //   className,
    //   ' @watch [body] : ',
    //   _body)
  }

  let _removeClsssFromBody = (className, delay = 100) => {
    let _body = document.querySelector("body")


    // console.log('App.vue', body)
    if (!_body) {
      setTimeout(() => {
        _removeClsssFromBody(className)
        runLoopCheck(times)
      }, delay)
      return
    }

    // console.log('_Mixins.js',
    //   '_removeClsssFromBody :',
    //   ' [before] ',
    //   ' @watch [className] : ',
    //   className,
    //   ' @watch [body] : ',
    //   _body)

    // let $body = $(_body)
    // $body.removeClass(className)
    _body.classList.remove(className)

    // console.log('_Mixins.js',
    //   '_removeClsssFromBody :',
    //   ' [after] ',
    //   ' @watch [className] : ',
    //   className,
    //   ' @watch [body] : ',
    //   _body)

  }

  let addClassToBody = (className, condition) => {
    // console.log('_Mixins.js',
    //   'addClassToBody :',
    //   ' @watch [className] : ',
    //   className,
    //   ' @watch [condition] : ',
    //   condition)

    _removeClsssFromBody(className)
    if (condition) {
      _addClsssToBody(className)
    } else {
      _removeClsssFromBody(className)
    }
  }

  if (!platform) {
    //debugger;
    runLoopCheck(times)
    return
  }
  if (!platform['os']) {
    //debugger;
    runLoopCheck(times)
    return
  }
  setTimeout(function () {
    // browser name in short and lowercase
    addClassToBody(platform['name'].toLowerCase(), true)

    addClassToBody('windows', platform.os.family.toLowerCase().indexOf('windows') != -1, true)

    if (platform.os.family.toLowerCase().indexOf('ios') != -1) {
      addClassToBody(platform.product.toLowerCase(), true, true)
    }

    addClassToBody('mobile', isMobile == true && isTablet == false)
    addClassToBody('not-mobile', isMobile == false)

    addClassToBody('tablet', isTablet == true)
    addClassToBody('not-tablet', isTablet == false)

    if (isMobile == false && isTablet == false) {
      addClassToBody('desktop', isTablet == true)
    }

    // console.log('_Mixins',
    //   '>> initPlatformAndMobileDetect',
    //   ' ## check platform : ',
    //   platform,
    //   ', isMobile : ',
    //   isMobile,
    //   ', isTablet',
    //   isTablet)
  })

  runLoopCheck(times)
}

const imageMixin = {

  methods: {
    getImageSrc(src) {
      if (src == '') return ''

      // let _regex = /.png$/
      // let _regex = /.+\.(png|svg|jpg|jpeg)$/

      let images = require.context('../assets/', true, /.+\.(png|svg|jpg|jpeg)$/i)
      // let images = require.context('../assets/', true)

      let path = `./${src}`
      // let path = `./${src}/${file}`

      return images(path)
    },
  }

}
const platformMixin = {

  mounted() {
    // console.log('_Mixin.js',
    //   'platformMixin mounted() !')
    // console.log('_Mixin.js',
    //   'mounted()',
    //   '@watch this.$router : ',
    //   this.$router,
    //   this.$router.afterEach)
    setTimeout(() => {
      initPlatformAndMobileDetect()
      // console.log('_Mixins.js',
      //   'mounted()',
      //   'check platform',
      //   ' watch this.getIsMobile : ',
      //   this.getIsMobile)
    }, 100)
  },

  methods: {
    doPlatformAndMobileDetect() {
      initPlatformAndMobileDetect()
    }
  },

  computed: {
    getIsTablet() {
      return isTablet
    },

    getIsMobile() {
      // 後來決定 tablet 不當成 mobile 來處理內容
      // 但上方選單就改長成 mobile 樣式的選單
      // 混合式

      // if (platform) {
      //   if (platform['product']) {
      //     let product = platform['product'].toLowerCase()
      //     if (product == 'ipad') return false
      //   }

      //   if (platform['os']) {
      //     let os = platform['os']

      //     if (os.toString) {
      //       os = os.toString().toLowerCase()

      //       if (os.indexOf('android') != -1) return false
      //     }
      //   }
      // }
      // console.log(platform)
      return isMobile
    },

    getPlatform() {
      return platform
    },
  },

  watch: {
    //   $route: function ($route) {
    //     setTimeout(() => {
    //       initPlatformAndMobileDetect()
    //     }, 100)
    //   },
    getIsMobile: function (value) {
      console.log('Mixins.js',
        ' watch getIsMobile : ',
        value)
    }
  }
}

const _default_Stage_Top = 600
const globalMixin = {

  data() {
    return {
      stage_top_pos: _default_Stage_Top,
      scroll_top: 0,
      series_prefix: '',
    }
  },

  mounted() {
    let _this = this

    let _scroll = function (target) {
      if (target && target.scrollTop) {
        _this.scroll_top = target.scrollTop()

        _this.updateStageTop()

        // console.log('_Mixins.js',
        //   'globalMixins',
        //   ' @watch scroll_top : ',
        //   _this.scroll_top,
        //   ' @watch stage_top_pos : ',
        //   _this.stage_top_pos)
      }
    }

    $(window).scroll(() => {
      _scroll($(window))
    })

    setTimeout(() => {
      initScrollTop()
      _scroll($(window))
    }, 100)
  },

  methods: {

    getAttribute(_obj, attributeName, defaultValue = '') {
      try {
        if (!_obj) return defaultValue

        if (!_obj.hasOwnProperty(attributeName)) return defaultValue

        if (!_obj[attributeName]) return defaultValue

        return _obj[attributeName]
      } catch (ex) {
        console.error(ex)

        return defaultValue
      }
    },

    updateStageTop() {
      this.stage_top_pos = this.getStageTop()
    },

    getStageTop() {
      // console.log('**', 'globalMixin', 'getStageTop called !')

      let _find_times = 0

      let _find_Stage_Top = function () {
        // debugger
        _find_times += 1

        let $stageTop = $('#stage-top')
        if ($stageTop.length == 0) {
          if (_find_times >= 5) {
            return _default_Stage_Top
          }

          setTimeout(_find_Stage_Top, 500)
          return _default_Stage_Top
        }

        // console.log('TopMenu.vue',
        //   'watch $stageTop',
        //   $stageTop,
        //   // 'watch $stageTop.position().top : ',
        //   // $stageTop.position().top,
        //   'watch $stageTop.offset().top : ',
        //   $stageTop.offset().top)

        return $stageTop.offset().top
      }

      return _find_Stage_Top()
    }
  },

  computed: {
    out_off_stage_top: function () {
      return this.scroll_top > this.stage_top_pos
    },

    stage_top: function () {
      return this.getStageTop()
    },
  }
}

let resourceDomain = 'http://media-dlc.sce.pccu.edu.tw/deep'

if (_config && _config['web']) {
  resourceDomain = _config['web']['resource_domain']
}

const courseMixin = {
  data() {
    return {
      courseMixin_Serieses: null,
      courseMixin_Course: null,
    }
  },

  // created() {
  //   console.log('_Mixins.js',
  //     '[router watch]',
  //     'created()')
  // },

  mounted() {
    let _this = this

    this.courseMixin_Serieses = null
    this.courseMixin_Course = null

    let timeoutIntervalId = 0
    let adjustScrollPosition = (name, hash) => {

      if (timeoutIntervalId != 0) {
        clearTimeout(timeoutIntervalId)
      }

      let scrollToHash = (hashTag) => {
        location.href = '/#/'

        setTimeout(() => {
          // console.log('scrollToHash :',
          //   hashTag,
          //   $(hashTag),
          //   $(hashTag).offset().top,
          //   $(window).scrollTop())

          // $(window).animate({
          //   'scrollTop': 0
          //     //$(hashTag).offset().top
          // }, 2000)
          location.href = '/#/' + hashTag
        }, 500)
      }

      if (name == 'Portal') {
        timeoutIntervalId =
          setTimeout(() => {
            //scrollToHash(hash);
          }, 1000)
      }
    }

    this.waitingCourseReady()
      .then((course) => {
        // console.warn('### _Mixins.js',
        //     new Date(),
        //     'mounted()',
        //     'waitingCourseReady()',
        //     'course :',
        //     course,
        //     'this.$route',
        //     this.$route)
        _this.courseMixin_Course = course

        // if (this.$route.name == 'Portal') {
        //   adjustScrollPosition(
        //     this.$route.name,
        //     this.$route.hash
        //   )
        // }
      })
  },

  methods: {
    ...mapMutations(['UpdateSeriesesFiles', 'UpdateSeriesesFilesLoading']),
    ...mapActions(['updateCourseInState', 'getSerieses']),

    prepareSerieses(_serieses) {
      _serieses = _.remove(_serieses, (series) => {
        return series['show-on-menu']
      })

      _serieses = _.orderBy(_serieses, 'menu-index')

      return _serieses
    },

    waitingSeriesesReady() {

    },

    waitingCourseReady(_resolve = null) {
      let _this = this

      // console.log('WaitingCourseReady entry point !')

      let _findCourse = function (resolve, serieses) {
        let course =
          _this.findCourseById(
            serieses,
            _this.series_id,
            _this.course_id)

        if (course !== undefined && course != null) {
          resolve(course)
          return course
        }
      }

      let waitingCoursePromise = () => {
        return new Promise(resolve => {

          let loadSeriesesToFindCourse = (_resolve) => {

            console.log('>>> _Mixins #443',
              'courseMixin',
              'waitingCourseReady',
              'this.Serieses',
              this.Serieses)

            console.log('### WaitingCourseReady #1 !')

            if (_this.getCourseIdReady == false) {
              console.log('### WaitingCourseReady #2 !')
              return _resolve(null)
            }

            console.log('### WaitingCourseReady #2-1 !',
              'this.Serieses',
              this.Serieses)

            _this.getSerieses()
              .then((serieses) => {
                var course =
                  _findCourse(_resolve, serieses)

                console.log('### _Mixins.js # 462',
                  'this.Serieses',
                  _this.Serieses,
                  'this.Serieses.length',
                  _this.Serieses.length,
                  'serieses',
                  serieses,
                  'course',
                  course,
                  'this.updateCourse',
                  this.updateCourse)

                this.courseMixin_Course = course
                return
              })
          }

          // console.log('_Mixins.js #525',
          //   'waitingCourseReady',
          //   'current watch !!',
          //   'this.Serieses',
          //   this.Serieses,
          //   'this.Serieses.length',
          //   this.Serieses.length,
          //   'this.seriesesFiles.length',
          //   this.seriesesFiles.length)

          if (this.Serieses.length == this.seriesesFiles.length) {
            _findCourse(resolve)
          }
          else {
            loadSeriesesToFindCourse(_resolve == null ? resolve : _resolve)
          }
        })
      }

      return waitingCoursePromise()
    },

    findCourseById(serieses, series_id, course_id) {
      let seriesIndex = _.findIndex(serieses, {
        id: parseInt(series_id)
      })

      // console.log('Mixins.js > getCourseById > seriesIndex : ', seriesIndex)

      if (seriesIndex == -1) return null

      let series = serieses[seriesIndex]

      //if (series == undefined) return null
      // console.log(series)

      let courseIndex = _.findIndex(series.courses, {
        id: parseInt(course_id)
      })

      // console.log('Mixins.js > getCourseById > courseIndex : ', courseIndex)

      if (courseIndex == -1) return null

      let course = series.courses[courseIndex]

      //if (course == undefined) return null

      return course
    },

    getCourse() {

      return new Promise(resolve => {
        // this.course = this.getCourseById(this.series_id, this.course_id)

        // return this.course
        // console.log('courseMixin > getCourse() > this.seriesesInState : ', this.seriesesInState)
        // console.log('courseMixin > getCourse() > this.series_id : ', this.series_id)
        // console.log('courseMixin > getCourse() > this.course_id : ', this.course_id)

        if (this.series_id == -1 || this.course_id == -1) {
          return null
        }

        if (this.courseMixin_Serieses != null) {
          if (this.courseMixin_Course &&
            this.courseMixin_Course.id == this.course_id) {
            return resolve(this.courseMixin_Course)
          }

          let course =
            this.findCourseById(this.courseMixin_Serieses,
              this.series_id,
              this.course_id
            )

          this.courseMixin_Course = course
          return resolve(course)
        }

        this.getCourseById(this.series_id, this.course_id)
          .then(course => {
            return resolve(course)
          })

        // console.log('courseMixin > getCourse() > course : ', course)

        //return course
      })
    },

    // TODO: 移到 computed
    getCourseSettingColors() {
      //let course = this.getCourse()
      let course = this.course

      if (course) {
        // console.log('_Mixins.js', 'methods', 'getCourseSettingColors', course)
        return course.colors
      }

      return
    },

    getImageUrl(src) {
      return `assets/_course/${src}`
    },

    getSeriesById(series_id) {
      return new Promise(resolve => {

        let findSeries = (serieses, series_id) => {
          console.log('_Mixins.js', 'getSeriesById', 'serieses', serieses)

          let seriesIndex = _.findIndex(serieses, { id: series_id })

          if (seriesIndex == -1) return null

          return serieses[seriesIndex]
        }

        this.getSerieses()
          .then(serieses => {
            return resolve(findSeries(serieses, series_id))
          })
      })
    },

    getCourseById(series_id, course_id) {
      // console.log('Mixins.js',
      //   'getCourseById',
      //   'seriesesInState',
      //   this.seriesesInState)
      return new Promise(resolve => {

        if (this.courseMixin_Serieses != null) {
          if (this.courseMixin_Course &&
            this.courseMixin_Course.id == course_id) {
            return resolve(this.courseMixin_Course)
          }

          let course =
            this.findCourseById(this.courseMixin_Serieses,
              series_id,
              course_id)

          this.courseMixin_Course = course

          if (course) return resolve(course)
        }

        this.getSerieses()
          .then(serieses => {
            // console.log('_Mixins.js',
            //     'getCourseById',
            //     'await getSerieses()',
            //     'serieses', serieses)

            if (serieses !== undefined) {
              this.courseMixin_Serieses = serieses
            }

            //console.log('Mixins.js > getCourseById > serieses : ', serieses, serieses.length)

            //console.trace()
            // console.log('Mixins.js > getCourseById > serieses.length : ', serieses.length)

            let _course =
              this.findCourseById(this.courseMixin_Serieses,
                series_id,
                course_id)
            if (_course) return resolve(_course)
          })
      })
    },

    getCourseImageSrc(src, name) {
      if (src == '') return ''

      let images = require.context('../assets/_course/', true, /.png$/)

      let path = `./${src}/${name}`

      return images(path)
    },

    getCourseImageSrcMore(src) {
      if (src == '') return ''

      let images = require.context('../assets/_course/', true, /.(png|jpg|jpeg)$/)

      let path = `./${src}`

      return images(path)
    },

    getImageSrc(src) {
      if (src == '') return ''

      // let _regex = /.png$/
      // let _regex = /.+\.(png|svg|jpg|jpeg)$/

      let images = require.context('../assets/', true, /.+\.(png|svg|jpg|jpeg)$/i)
      // let images = require.context('../assets/', true)

      let path = `./${src}`
      // let path = `./${src}/${file}`

      return images(path)
    },

    combineFullResourceUrl(resourceUrl, needPrefix = true, series_id = -1) {

      let isNeededToCombine = true
      if (resourceUrl.startsWith('//') ||
        resourceUrl.startsWith('http') ||
        resourceUrl.startsWith('rtsp') ||
        resourceUrl.startsWith('rtmp')) {
        isNeededToCombine = false
      }
      if (isNeededToCombine == false) return resourceUrl

      if (resourceUrl.startsWith('/') == false) {
        resourceUrl = '/' + resourceUrl
      }

      if (needPrefix == false) {
        console.log(resourceDomain + resourceUrl)
        return resourceDomain + resourceUrl
      }

      // console.log('combineFullResourceUrl getSeriesById(): ', this.getSeriesById(this.series_id))
      if (this.series_id != -1) series_id = this.series_id

      //let series = this.getSeriesById(series_id)
      this.getSeriesById(series_id)
        .then(series => {
          // console.log('combineFullResourceUrl getSeriesById(): ',
          //   series,
          //   series_id)

          if (series && series.hasOwnProperty('prefix')) {
            this.series_prefix = series.prefix
          }

          //let src = this.series_prefix + resourceUrl
          let prefix =
            this.series_prefix == undefined || this.series_prefix == '' ?
              '' :
              this.series_prefix

          let src = prefix + resourceUrl

          if (src.startsWith('/') == false) {
            src = '/' + src
          }

          // console.log('_Mixins.js',
          //   ' @@ check src',
          //   src)

          // return resourceDomain + '/' + this.series_prefix + resourceUrl
          //console.log(resourceDomain + src)
          return resourceDomain + src
        })


    },

    isInViewport(elem, callback) {
      //if (elem && elem.getBoundingClientRect)
      if (!elem) return
      if (!elem.getBoundingClientRect || !elem.getBoundingClientRect) return
      if (elem.getBoundingClientRect() == null) return

      var bounding = elem.getBoundingClientRect()

      let testInViewport = (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )

      if (testInViewport) {
        if (callback) {
          callback(elem)
          return
        }
      }

      return testInViewport
    },
  },

  computed: {
    ...mapState(['seriesesInState', 'seriesesFiles']),
    ...mapGetters(['Serieses']),

    getCourseTitleImageSrc() {
      console.log('_Mixins',
        'getCourseTitleImageSrc',
        'this.course',
        this.course)

      if (this.course == null || this.course == undefined) return ''

      let src = this.course.assets_path
      let file = this.course.title_image

      if (src == undefined) return ''
      if (src == '') return ''

      let images = require.context('../assets/_course/', true)

      // let path = `./${src}/page_TITLE.${findExtMappingSequence[searchIndex]}`
      let path = `./${src}/${file}`

      // console.log('_Mixins',
      //   'getCourseTitleImageSrc',
      //   images(path))

      try {
        console.warn('>>>>>> getCourseTitleImageSrc',
          path,
          images(path))

        return images(path)

        // if (result && result != '') {
        //   return result
        // }

        // return this.getCourseTitleImageSrc(src, ++searchIndex)
      } catch (ex) {
        throw ex
      }
    },

    getSeriesesInState() {
      return this.Serieses
    },

    getCourseIdReady() {
      if (this.series_id == -1) return false
      if (this.course_id == -1) return false

      // if (this.getSerieses().length > 1) {
      //   return true
      // }
      // else {
      //   return false
      // }
      return true
    },

    getCurrentCourse() {
      return new Promise(resolve => {
        if (this.course &&
          this.course.id == this.course_id) {
          return resolve(this.course)
        }

        this.getCourse()
          .then(course => {
            return resolve(course)
          })
      })
    },

    route_name() {
      return this.$route
    },

    series_id() {
      try {
        if (this.$route.params.hasOwnProperty('series_id')) {
          return parseInt(this.$route.params.series_id)
        }

        return -1
      } catch (ex) {
        return -1
      }
    },

    // series_prefix() {

    //   let series_id = this.series_id

    //   if (series_id == -1) return ''

    //   series_id = parseInt(series_id)

    //   let serieses = this.getSerieses()

    //   let seriesIndex = _.findIndex(serieses, { id: series_id })

    //   if (seriesIndex != -1) {
    //     return serieses[seriesIndex].prefix
    //   }

    //   return ''
    // },

    course_id() {
      try {
        if (this.$route.params.hasOwnProperty('course_id')) {
          return parseInt(this.$route.params.course_id)
        }

        return -1
      } catch (ex) {
        return -1
      }
    },

    serieses() {
      return this.courseMixin_Serieses
    },

    course() {
      // if (this.course == null) {
      //   this.course = this.getCourseById(this.series_id, this.course_id)
      // }

      // return this.course
      // return this.getCourseById(this.series_id, this.course_id)
      //return this.courseMixin_Course
      // console.log('_Mixins.js',
      //   '#970 course()',
      //   'this.seriesesInState',
      //   this.seriesesInState)

      return this.courseMixin_Course
    },

    currentWeeks() {
      if (this.course) {
        return this.course.weeks
      }

      return []
    },

    sprite_image_src() {
      return this.getImageSrc('sprite.png')
    }
  }
}

const GuardMixin = {

  methods: {
    scrollToPosition(position, scrollSeconds = 500) {
      var body = $("html, body");
      body.stop().animate({ scrollTop: position }, scrollSeconds, 'swing', function () {
      });
    },

    scrollToHash(to) {
      var $el = $(to['hash'])

      // console.log('>>> GuardMixin beforeRouteUpdate',
      //   '$el',
      //   $el)

      if ($el.length == 0) {
        // console.log('>>> GuardMixin beforeRouteUpdate',
        //   '$el top :',
        //   $el.offset().top,
        //   'current top :',
        //   $(document).scrollTop())
        setTimeout(() => {
          this.scrollToHash(to);
        }, 200)
      }
      else {
        let _top = $el.offset().top

        _top -= $(window).height() > 1000 ? 100 : 50

        if (_top < 0) top = 0
        this.scrollToPosition(_top)
      }
    }
  },

  beforeRouteUpdate(to, from, next) {
    // let _this = this
    // console.log('>>> GuardMixin beforeRouteUpdate',
    //   '[router watch]',
    //   this,
    //   to,
    //   from)
    // if (to && from) {
    //   if (to['hash'] && from['hash'] &&
    //     to['hash'] !== from['hash']) {
    //       location.href = to['hash']
    //     }
    // }
    // setTimeout(function() {
    //   _this.scrollToHash(to)
    // })

    // next(vm => {
    //     vm.$parent.logs.push('mixin')
    // })
    next(false)
  },
  // beforeRouteEnter(to, from, next) {
  //     alert('beforeRouteEnter')
  //     next(vm => {
  //         vm.$parent.logs.push('mixin')
  //     })
  // },
  // beforeRouteLeave(to, from, next) {
  //     alert('beforeRouteLeave')
  //     next(vm => {
  //         vm.$parent.logs.push('mixin')
  //     })
  // }
}

export {
  globalMixin,
  platformMixin,
  imageMixin,
  courseMixin,
  GuardMixin
}



// WEBPACK FOOTER //
// ./src/components/_Mixins.js